import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'
import { saleQueryOptions } from '../../../../features/pos/queries'
import { PosSalePage } from '../../../../features/pos/sale-page'

/** A till sale and its receipt (reprint), for whoever may see till sales. */
export const Route = createFileRoute('/_app/pos/sales/$saleId')({
  staticData: { crumb: 'posSale' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'pos.sell', 'pos.view_shift', 'pos.return', 'pos.void'),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(saleQueryOptions(params.saleId)),
  component: PosSalePage,
})
